<template>
   <v-container>
        <div class="text-left" style="margin-bottom:20px;">
            <router-link to="/uk">
                <v-btn
                    color="secondary"
                    class="text-right"
                    style="width:250px"
                >
                    Back
                </v-btn>
            </router-link>
        </div>           
      <v-row>
        <v-col cols="12" class="text-left">
          <h1>February 1</h1>
          <div class="text-left">
              <p>The car has a check coolant turn off engine and check coolant message.  Frank investigated once it was worked out how to open the bonnet.</p>
              <img alt="frank checking coolant" class="uitk-image-media" src="/uk/frankcoolant.jpeg" style="width: 17%; height: auto;">                
          </div>      
          <div class="text-left">
              <p>We drove to the white hills of Dover.</p>
              <img alt="Dover" class="uitk-image-media" src="/uk/dover.jpeg" style="width: 17%; height: auto;">                
          </div>     
          <div class="text-left">
              <p>Photo of Frank looking at the white hills of Dover.</p>
              <img alt="Dover Frank" class="uitk-image-media" src="/uk/frankdover.jpeg" style="width: 17%; height: auto;">                
          </div>           
          <div class="text-left">
              <p>Brought the 2 million pound scratchie and UK lottery tickets.</p>
              <img alt="Dover Frank" class="uitk-image-media" src="/uk/lottery.jpeg" style="width: 17%; height: auto;">                
          </div>                             
        </v-col>
      </v-row>
    </v-container>
  </template>
  
  <script>
  
  //vue 3 style
  import { ref } from 'vue'
  
  export default {
    name: 'HomeView',
    setup() {
    }
  }
  </script>